import { PriceDTO, ProductDTO } from "@campgladiator/cg-common.types.types";

export const getActiveProductPriceById = ({
  prices,
  productId,
  currency = "USD",
}: {
  prices?: PriceDTO[];
  productId: ProductDTO["stripeProductId"];
  currency?: PriceDTO["currency"];
}) =>
  prices?.find(
    (price: PriceDTO) =>
      price.active &&
      !price.deleted &&
      price.currency.toLowerCase() === currency.toLowerCase() &&
      price.stripeProductId === productId
  );
